import React, { useEffect, useState, useRef } from "react";
import { NavLink, useMatch, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { colors } from "../../Shared/colors";
import { store } from "../../app/store";
import { apiSlice } from "../../features/api/apiSlice";
import { logo } from "../../Shared/config";
import { useLogoutMutation } from "../../features/employeeSlice";
import { useChangePasswordMutation } from "../../features/authSlice";
import { Toaster, toast } from "react-hot-toast";
import {
  addEmp,
  notificationCount,
  postgetNotify,
  whenConnected,
} from "../../services/socket";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { decryptData } from "../../services/crypto";
import { useGetAllNotificationsQuery, useReadAllMutation } from "../../features/notificationSlice";
import ProfileCard from "../profileCard/ProfileCard";
import moment from "moment";

export const Header = ({ staff }) => {
  let login = useMatch("/login");
  let notFound = useMatch("/notfound");
  let changePassword = useMatch(`/changePassword/:token`);
  let unAuthorized = useMatch("/unauthorized");
  let match = false;
  const token = localStorage.getItem('token');
  if (login || notFound || unAuthorized || changePassword) {
    match = true;
  }

  const [Notifications, setNotifications] = useState();
  const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
  const notificationRef = useRef(null);

  let empId = null;
  let storedStaffId = localStorage.getItem("id");

  if (storedStaffId) {
    try {
      empId = decryptData(storedStaffId);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }
  let fullName = null;
  let storedStaffName = localStorage.getItem("staffName");

  if (storedStaffName) {
    try {
      fullName = decryptData(storedStaffName);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }

  useEffect(() => {
    const connectAndAddEmployee = () => {
      try {
        if (empId && fullName) {
          console.log(`👤 Adding employee to socket: ${fullName} (${empId})`);
          addEmp(empId, fullName);
        }
        if (empId) {
          console.log(`📤 Requesting notifications for employee: ${empId}`);
          postgetNotify(empId);
        }
      } catch (error) {
        console.error("Error in addEmp or postgetNotify:", error);
      }
    };

    // Use whenConnected to ensure socket is ready
    whenConnected(connectAndAddEmployee);
  }, [empId, fullName]);

  useEffect(() => {
    try {
      notificationCount((data) => {
        setNotifications(data);
      });
    } catch (error) {
      console.error("Error in notificationCount:", error);
    }
  }, []);

  const [changePass] = useChangePasswordMutation();

  const { data: notificationsData, refetch } = useGetAllNotificationsQuery(undefined, { skip: !token });
  const [readAll, { isLoading: readLoading }] = useReadAllMutation();
  const isRead = notificationsData?.some(notification => !notification.isRead);
  const unreadCount = notificationsData?.filter(notification => !notification.isRead).length || 0;

  let user = null;
  const storedData = localStorage.getItem("user");

  if (storedData) {
    try {
      user = decryptData(storedData);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }


  const navigate = useNavigate();

  // Helper function to get appropriate icon based on notification type
  const getNotificationIcon = (type, isRead) => {
    if (isRead) return '✓';

    switch (type) {
      case 'Assigned Leads':
      case 'Lead Assignment':
        return '👤';
      case 'Payment':
      case 'Payment Initiated':
      case 'Payment Completed':
      case 'Payment Rejected':
        return '💰';
      case 'Meeting':
      case 'Meeting Reminder':
        return '📅';
      case 'Task':
        return '✅';
      case 'Policy':
      case 'broadcast':
        return '📋';
      case 'Facebook Lead':
        return '📘';
      case 'Feedback':
        return '💬';
      default:
        return '🔔';
    }
  };

  // Handle notification dropdown toggle
  const handleNotificationClick = (e) => {
    e.preventDefault();
    setShowNotificationDropdown(!showNotificationDropdown);
  };

  // Handle mark all as read
  const handleMarkAllAsRead = () => {
    readAll()
      .unwrap()
      .then((res) => {
        toast.success("Marked all as read!");
        refetch();
      })
      .catch((err) => {
        toast.error("Unable to mark all notifications as read!");
      });
  };

  // Handle navigation to full notifications page
  const handleViewAllNotifications = () => {
    setShowNotificationDropdown(false);
    navigate("/leads/notifications");
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotificationDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = (preservePath = false, isAutoLogout = false) => {
    if (preservePath && isAutoLogout) {
      const currentPath = window.location.pathname + window.location.search;
      sessionStorage.setItem("redirectPath", currentPath);
      sessionStorage.setItem("autoLogout", "true");
    } else {
      sessionStorage.removeItem("redirectPath");
      sessionStorage.removeItem("autoLogout");
    }

    // Clear user data only
    ["token", "id", "staffName", "role", "email", "user"].forEach((key) =>
      localStorage.removeItem(key)
    );

    store.dispatch(apiSlice.util.resetApiState());
    setdrop(false);

    // Add a slight delay before navigation
    setTimeout(() => navigate("/login", { replace: true }), 100);
  };


  const handleReset = (e) => {
    e.preventDefault();

    let staffEmail = null;
    let storedStaffEmail = localStorage.getItem("email");

    if (storedStaffName) {
      try {
        staffEmail = decryptData(storedStaffEmail);
      } catch (error) {
        console.error("Failed to decrypt data:", error);
      }
    }

    let data = {
      email: staffEmail,
    };
    changePass(data)
      .unwrap()
      .then((res) => {
        toast.success("Please check your email inbox");
        setTimeout(() => {
          window.open("https://mail.google.com/mail/u/0/#inbox", "_blank");
        }, 1500);
      })
      .catch((err) => {
        toast.error("error");
      });
  };
  const [logout] = useLogoutMutation();
  const handleAPILogout = async () => {
    try {
      await logout().unwrap();
      handleLogout(false, false); // Manual logout, don't preserve path
    } catch (error) {
      console.error("Logout error:", error);
      // Even if API logout fails, still perform local logout
      handleLogout(false, false);
    }
  };

  // Enhanced automatic logout function for token expiry
  const handleAutoLogout = () => {
    handleLogout(true, true); // Automatic logout, preserve path
  };

  useEffect(() => {
    if (isRead) {
      // Unread notifications detected - handled silently in production
    }
  }, [isRead]);

  const [drop, setdrop] = useState(false);
  return (
    <Main match={match}>
      <Logo>
        <img src={logo} alt="logo" />
      </Logo>
      <Container>
        <NavLink to={user?.role === "ts" ? "/telesale" : "/"} end>
          Dashboard
        </NavLink>
        <NavLink to="leads">Leads</NavLink>
        {/* {(user?.role === "ceo" || user?.role === "admin" || user?.role === "sm") && ( <NavLink to="social">SMM</NavLink>)} */}
        {user?.role !== "ts" && (
          <NavLink to="clients">Clients</NavLink>
        )}
        {(user?.role === "ceo" || user?.role === "admin") && (<NavLink to="staff">Staff</NavLink>)}
        {user?.role !== "ts" && (
          <>
            <NavLink to="affiliate">Affiliate</NavLink>
            <NavLink to="inventory">Inventory</NavLink>
            <NavLink to="accounts">Accounts</NavLink>
          </>
        )}
        <NavLink to="targets">Targets</NavLink>
        <NavLink to="reports">Reports</NavLink>
        {user?.role !== "ts" && (
          <>
            <NavLink to="training">Training</NavLink>
          </>
        )}
        <NavLink to="policies">Policies</NavLink>
        {user?.role !== "ts" && (
          <>
            <NavLink to="documentation">Documentation</NavLink>
          </>
        )}
      </Container>
      <ProfileSection>
        <NotificationContainer ref={notificationRef}>
          <NotificationTab onClick={handleNotificationClick}>
            <NotificationsActiveIcon />
            {unreadCount > 0 && (
              <NotificationBadge>
                {unreadCount > 9 ? '9+' : unreadCount}
              </NotificationBadge>
            )}
          </NotificationTab>

          {showNotificationDropdown && (
            <NotificationDropdown>
              <DropdownHeader>
                <DropdownTitle>
                  <NotificationIcon>🔔</NotificationIcon>
                  Notifications
                  {unreadCount > 0 && (
                    <UnreadCount>{unreadCount} unread</UnreadCount>
                  )}
                </DropdownTitle>
                <DropdownActions>
                  <ActionButton onClick={handleMarkAllAsRead} disabled={readLoading}>
                    {readLoading ? (
                      <>
                        <LoadingSpinner />
                        Processing...
                      </>
                    ) : (
                      <>
                        ✓ Mark All as Read
                      </>
                    )}
                  </ActionButton>
                </DropdownActions>
              </DropdownHeader>

              <NotificationList>
                {notificationsData && notificationsData.length > 0 ? (
                  notificationsData.slice(0, 5).map((notification, index) => (
                    <NotificationItem key={notification._id || index} isRead={notification?.isRead} type={notification?.type}>
                      <NotificationContent>
                        <NotificationIcon isRead={notification?.isRead} type={notification?.type}>
                          {getNotificationIcon(notification?.type, notification?.isRead)}
                        </NotificationIcon>
                        <NotificationText>
                          <NotificationType>{notification?.type || 'Notification'}</NotificationType>
                          <Message>{notification?.message}</Message>
                          <Timestamp>{moment(new Date(notification?.createdAt)).fromNow(true)} ago</Timestamp>
                        </NotificationText>
                      </NotificationContent>
                      {!notification?.isRead && <UnreadIndicator type={notification?.type} />}
                    </NotificationItem>
                  ))
                ) : (
                  <EmptyState>
                    <EmptyIcon>📭</EmptyIcon>
                    <EmptyText>No new notifications</EmptyText>
                  </EmptyState>
                )}
              </NotificationList>

              {notificationsData && notificationsData.length > 5 && (
                <DropdownFooter>
                  <ViewAllButton onClick={handleViewAllNotifications}>
                    View All Notifications ({notificationsData.length})
                  </ViewAllButton>
                </DropdownFooter>
              )}
            </NotificationDropdown>
          )}
        </NotificationContainer>
        {!token ? (
          <p>Please log in to view data.</p>
        ) : (
          <ProfileCard
            user={user}
            staff={staff}
            handleLogout={handleAPILogout}
            handleReset={handleReset}
            handleAutoLogout={handleAutoLogout}
          />
        )}
      </ProfileSection>

      <Toaster />
    </Main >
  );
};

const Main = styled.div`
  position: fixed;
  height: 10vh;
  width: 100%;
  display: ${(props) => (props.match ? "none" : "flex")};
  justify-content: space-between;
  align-items: center;
  background-color: ${colors.white};
  z-index: 10;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 1024px) {
    height: 8vh;
    padding: 0 1rem;
  }
  
  @media (max-width: 768px) {
    height: 7vh;
    padding: 0 0.5rem;
  }
`;
const Logo = styled.div`
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  
  img {
    width: 30%;
    height: 100%;
    object-fit: contain;
  }
  
  @media (max-width: 1200px) and (min-width: 1025px) {
    width: 18%;
    
    img {
      width: 35%;
    }
  }
  
  @media (max-width: 1024px) {
    width: 15%;
    
    img {
      width: 40%;
    }
  }
  
  @media (max-width: 768px) {
    width: 12%;
    
    img {
      width: 50%;
    }
  }
`;

const Container = styled.div`
  width: 70%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
  
  a {
    height: 100%;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 2px solid white;
    color: ${colors.textLight};
    transition: all 0.3s ease-out;
    font-size: clamp(0.8rem, 1.2vw, 1.1rem);
    padding: 0 0.5rem;
    white-space: nowrap;
    flex-shrink: 0;
    min-width: fit-content;
    
    :hover {
      color: ${colors.brown};
      border-bottom: 2px solid ${colors.brown};
    }
  }
  
  .active {
    color: ${colors.brown};
    border-bottom: 2px solid ${colors.brown};
  }
  
  @media (max-width: 1200px) and (min-width: 1025px) {
    width: 65%;
    justify-content: flex-start;
    gap: 0.4rem;
    
    a {
      font-size: 0.85rem;
      padding: 0 0.25rem;
    }
  }
  
  @media (max-width: 1024px) {
    width: 70%;
    justify-content: flex-start;
    gap: 0.5rem;
    
    a {
      font-size: 0.9rem;
      padding: 0 0.3rem;
    }
  }
  
  @media (max-width: 768px) {
    width: 75%;
    gap: 0.3rem;
    
    a {
      font-size: 0.8rem;
      padding: 0 0.2rem;
    }
  }
`;
const NotificationContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  
  @media (max-width: 1200px) and (min-width: 1025px) {
    margin-left: 0.3rem;
  }
  
  @media (max-width: 1024px) {
    margin-left: 0.5rem;
  }
  
  @media (max-width: 768px) {
    margin-left: 0.3rem;
  }
`;

const NotificationTab = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-left: 20px;
  cursor: pointer;
  color: black;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${colors.lightWhite};
    transform: scale(1.05);
  }
  
  @media (max-width: 1200px) and (min-width: 1025px) {
    margin-left: 15px;
    padding: 7px;
  }
  
  @media (max-width: 1024px) {
    margin-left: 10px;
    padding: 6px;
  }
  
  @media (max-width: 768px) {
    margin-left: 5px;
    padding: 4px;
  }
`;

const NotificationBadge = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
  animation: pulse 2s infinite;
  
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(239, 68, 68, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
    }
  }
  
  @media (max-width: 1200px) and (min-width: 1025px) {
    width: 19px;
    height: 19px;
    font-size: 0.68rem;
  }
  
  @media (max-width: 1024px) {
    width: 18px;
    height: 18px;
    font-size: 0.65rem;
  }
  
  @media (max-width: 768px) {
    width: 16px;
    height: 16px;
    font-size: 0.6rem;
  }
`;

const NotificationDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  width: 400px;
  max-height: 500px;
  background: ${colors.white};
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.05);
  z-index: 1000;
  overflow: hidden;
  animation: slideDown 0.3s ease-out;
  
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @media (max-width: 1200px) and (min-width: 1025px) {
    width: 375px;
    max-height: 450px;
  }
  
  @media (max-width: 1024px) {
    width: 350px;
    max-height: 400px;
  }
  
  @media (max-width: 768px) {
    width: 300px;
    max-height: 350px;
    right: -50px;
  }
`;

const DropdownHeader = styled.div`
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
  padding: 1.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DropdownTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: ${colors.text};
`;

const UnreadCount = styled.span`
  background: ${colors.brown};
  color: ${colors.white};
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
`;

const DropdownActions = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
  color: ${colors.white};
  box-shadow: 0 2px 8px rgba(36, 147, 147, 0.3);
  
  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(36, 147, 147, 0.4);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const LoadingSpinner = styled.div`
  width: 12px;
  height: 12px;
  border: 2px solid transparent;
  border-top: 2px solid ${colors.white};
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const NotificationList = styled.div`
  max-height: 300px;
  overflow-y: auto;
  padding: 0.5rem;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: ${colors.lightWhite};
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${colors.brown};
    border-radius: 2px;
  }
`;

const NotificationItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  background: ${props => props.isRead ? colors.lightWhite : colors.white};
  border: 1px solid ${props => props.isRead ? colors.inputBorderWhite : getTypeColor(props.type)};
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: ${props => getTypeColor(props.type)};
  }
  
  ${props => !props.isRead && `
    border-left: 3px solid ${getTypeColor(props.type)};
  `}
`;

const NotificationContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  flex: 1;
`;

const NotificationIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${props => props.isRead ? colors.lightWhite : getTypeColor(props.type)};
  color: ${props => props.isRead ? colors.textMed : colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  flex-shrink: 0;
  border: 2px solid ${props => props.isRead ? colors.inputBorderWhite : getTypeColor(props.type)};
`;

const NotificationText = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const NotificationType = styled.div`
  color: ${colors.textMed};
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const Message = styled.div`
  color: ${colors.text};
  font-size: 0.85rem;
  font-weight: 500;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Timestamp = styled.div`
  color: ${colors.textMed};
  font-size: 0.7rem;
  font-weight: 400;
`;

const UnreadIndicator = styled.div`
  width: 6px;
  height: 6px;
  background: ${props => getTypeColor(props.type) || colors.brown};
  border-radius: 50%;
  flex-shrink: 0;
  margin-left: 0.5rem;
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
`;

const EmptyIcon = styled.div`
  font-size: 2rem;
  margin-bottom: 0.5rem;
  opacity: 0.5;
`;

const EmptyText = styled.div`
  color: ${colors.textMed};
  font-size: 0.9rem;
  font-weight: 500;
`;

const DropdownFooter = styled.div`
  padding: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  background: ${colors.lightWhite};
`;

const ViewAllButton = styled.button`
  width: 100%;
  padding: 0.75rem;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
  color: ${colors.white};
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(36, 147, 147, 0.4);
    background: linear-gradient(135deg, #1a6b6b 0%, ${colors.brown} 100%);
  }
`;

const ProfileSection = styled.div`
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-shrink: 0;
  min-width: 120px;
  
  @media (max-width: 1200px) and (min-width: 1025px) {
    width: 17%;
    justify-content: flex-end;
    gap: 0.4rem;
    min-width: 140px;
  }
  
  @media (max-width: 1024px) {
    width: 15%;
    justify-content: flex-end;
    gap: 0.5rem;
    min-width: 120px;
  }
  
  @media (max-width: 768px) {
    width: 13%;
    justify-content: flex-end;
    gap: 0.3rem;
    min-width: 100px;
  }
`;

// Helper function to get color based on notification type
const getTypeColor = (type) => {
  switch (type) {
    case 'Assigned Leads':
    case 'Lead Assignment':
      return '#3b82f6'; // Blue
    case 'Payment':
    case 'Payment Initiated':
    case 'Payment Completed':
    case 'Payment Rejected':
      return '#10b981'; // Green
    case 'Meeting':
    case 'Meeting Reminder':
      return '#f59e0b'; // Amber
    case 'Task':
      return '#8b5cf6'; // Purple
    case 'Policy':
    case 'broadcast':
      return '#ef4444'; // Red
    case 'Facebook Lead':
      return '#1877f2'; // Facebook Blue
    case 'Feedback':
      return '#06b6d4'; // Cyan
    default:
      return colors.brown;
  }
};